import { Chip, alpha } from "@mui/material";
import { STAND_TYPE_OPTIONS } from "../../../../models/Section";

type Props = {
	code: "U" | "E" | null;
};

export const StandTypeChip = ({ code }: Props) => {
	if (!code) return null;
	const paletteKey = code === "U" ? "primary" : "secondary";
	return (
		<Chip
			size="small"
			label={STAND_TYPE_OPTIONS.find((o) => o.code === code)?.name}
			sx={{
				height: 20,
				fontSize: 12,
				fontWeight: 600,
				color: (theme) => theme.palette[paletteKey].main,
				backgroundColor: (theme) => alpha(theme.palette[paletteKey].main, 0.1),
			}}
		/>
	);
};
